module.exports = __webpack_public_path__ + "static/media/adjectives_img.370891cb.JPG";